<template>
	<el-dialog class="addDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				画师简介
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="在线时间：" prop="hs_time">
					<el-input v-model="ruleForm.hs_time" placeholder="请输入在线时间" />
				</el-form-item>
				<el-form-item label="偏好类型：" prop="hs_ph">
					<el-input v-model="ruleForm.hs_ph" placeholder="请输入偏好类型" />
				</el-form-item>
				<el-form-item label="不接类型：" prop="hs_bj">
					<el-input v-model="ruleForm.hs_bj" placeholder="请输入不接类型" />
				</el-form-item>
				<el-form-item label="约稿须知：" prop="hs_yg">
					<el-input type="textarea" :rows="3" maxlength="200" v-model="ruleForm.hs_yg"
						placeholder="请输入约稿须知" />
				</el-form-item>
				<el-form-item label="定制须知：" prop="hs_dj">
					<el-input type="textarea" :rows="3" maxlength="200" v-model="ruleForm.hs_dj"
						placeholder="请输入定制须知" />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium" @click="submitForm('ruleForm')">提交</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import citys from "@/assets/js/citys.js";
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => {},
			}
		},
		watch: {
			data: {
				handler(newValue) {
					this.ruleForm = {
						...newValue
					}
				},
				deep: true
			}
		},
		data() {
			return {
				ruleForm: {
					hs_time: '',
					hs_ph: '',
					hs_bj: '',
					hs_yg: '',
					hs_dj: ''
				},
				rules: {
					hs_time: [{
						required: true,
						message: '请输入在线时间',
						trigger: 'blur'
					}],
					hs_ph: [{
						required: true,
						message: '请输入偏好类型',
						trigger: 'blur'
					}],
					hs_bj: [{
						required: true,
						message: '请输入不接类型',
						trigger: 'blur'
					}],
					hs_yg: [{
						required: true,
						message: '请输入约稿须知',
						trigger: 'blur'
					}],
					hs_dj: [{
						required: true,
						message: '请输入定制须知',
						trigger: 'blur'
					}],
				},
				citys: citys,
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/xinxi_save', {
							...this.ruleForm,
						}).then(res => {
							if (res.code == 1) {
								this.$emit('update')
								this.handleClose()
							} else {
								this.$message.error(res.msg)
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.addDialog {

		::v-deep .el-dialog {
			width: 5.5rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {
							.el-textarea {
								&__inner {
									width: 4.1rem;
									padding: .08rem .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									border: .01rem solid #EFD8B8;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									padding: 0 .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
<style>
	.el-cascader-node {
		margin-bottom: 0 !important;
	}
</style>